export const layTimDuongUrlTheoHaHuyen = (maHuyen: string) => {
  const serviceUrl = process.env.REACT_APP_SERVICE_URL;
  if (!serviceUrl)
    throw new Error("Service URL chưa được khai báo trong file env.");
  const link = `${serviceUrl}TimDuong/`;
  switch (maHuyen) {
    case "747":
      return `${link}TimDuongBienTap_ThanhPhoVungTau_747/MapServer`;
    case "751":
      return `${link}TimDuongBienTap_HuyenXuyenMoc_751/MapServer`;
    case "755":
      return `${link}TimDuongBienTap_HuyenConDao_755/MapServer`;
    case "752":
      return `${link}TimDuongBienTap_HuyenLongDien_752/MapServer`;
    case "748":
      return `${link}TimDuongBienTap_ThanhPhoBaRia_748/MapServer`;
    case "754":
      return `${link}TimDuongBienTap_ThiXaPhuMy_754/MapServer`;
    case "750":
      return `${link}TimDuongBienTap_HuyenChauDuc_750/MapServer`;
    case "753":
      return `${link}TimDuongBienTap_HuyenDatDo_753/MapServer`;
    default:
      throw new Error("Không tìm thấy mã huyện");
  }
};

export const getRanhThuaTheoHuyenXaUrl = (maHuyen: string, maXa: string) => {
  const url = process.env.REACT_APP_RANH_THUA;
  return url
    ?.replace("[maDVHC_Huyen_TP]", maHuyen)
    .replace("[maDVHC_Phuong_Xa]", maXa);
};

export const getDuLieuNenUrl = (maHuyen: string) => {
  const url = process.env.REACT_APP_DU_LIEU_NEN_URL;
  if (!url) throw new Error("Đường dẫn dữ liệu nền chưa được khai báo");
  return `${url}${maHuyen}/MapServer`;
};
export const getRanhThuaURl = () => {
  const ranhThuaUrl = process.env.REACT_APP_RANH_THUA_SERVICE_URL;
  if (!ranhThuaUrl) throw new Error("Ranh thua url chưa được khai báo");
  return ranhThuaUrl;
};
